import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import giftSummaryApi from '../../../api/giftSummaryApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'giftSummary';

export const GetGiftSummary = createAsyncThunk(`${REDUCER_NAME}/getGiftSummary`, async (params: any, thunkAPI) => {
  params.startDate = dayjs(params.startDate).format('YYYY-MM-DD');
  params.endDate = dayjs(params.endDate).format('YYYY-MM-DD');

  const res = await giftSummaryApi.getAllGiftSummaries(params);

  if (res.status === 200) {
    return { ...res.data?.data, startDate: params.startDate, endDate: params.endDate };
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});
